import styled from 'styled-components';
import { darken } from 'polished';

export const StyledTable = styled.table`
  &&& {
    font-size: 14px;

    border-collapse: separate;
    border-spacing: 0 10px; /* 0 for horizontal, 10px for vertical space between rows */

    thead tr th {
      font-size: 13px;
      font-weight: 600;
      padding: .4rem 1rem;
      color: #78829d;
      /* vertical-align: middle;
      background-color: #fcfcfc;
      border-bottom: 1px solid #f1f1f4;
      border-right: 1px solid #f1f1f4; */
    }

    tbody tr td {
      padding: .75rem 1rem;
      vertical-align: middle;
      font-weight: 400;
      border-color: rgb(48, 48, 185);
      border: 1px solid #f1f1f4;
      background-color: #f9fafd;
      margin-top: 8px !important;
      border-right: none;
      border-left: none;
      height: 56.8px;
    }
    
    tbody tr:hover td {
      background-color: ${darken(0.02, '#f9fafd')};  
    }    

    tbody tr.clear td {
      border: none;
      background-color: transparent;
      height: auto !important;
    }

    tbody tr.clear:hover {
      background-color: transparent;
    }

    tbody tr td:first-child {      
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-left: 1px solid #f1f1f4;
    }

    tbody tr td:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-right: 1px solid #f1f1f4;
    }

    tbody tr.clear td:first-child {
      border-left: none;
    }

    tbody tr.clear td:last-child {
      border-right: none;
    }

    /* tbody tr.borderDanger {      
      td {
        border-color:rgb(240, 78, 94);
      }
    }       */
  }
`;

export default StyledTable;
